// Once an account has a passkey, adding another one (or renaming/revoking an
// existing one) requires the current session to have been established via
// passkey login - mirrors owner-api's OwnerAuthController.assertCanAddPasskey.
// The very first passkey is exempt since bootstrapping requires a password
// session (there's no passkey to sign in with yet).
export default function canManagePasskeys(hasEnrolledPasskey, usedPasskey) {
  return !hasEnrolledPasskey || Boolean(usedPasskey);
}
